import React from 'react';

import { Page, useExecutiveCheckupRouter } from '../../router/context';
import { saveSchedule } from '../../../../modules/slots';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { createScheduleRequest } from '../../../../models/ScheduleRequest';
import { usePatientContext } from '../../../../contexts/PatientContext';
import { AppointmentConfirmationTemplate } from '../../../../templates/AppointmentConfirmationTemplate';
import { ScheduleCard } from './components/ScheduleCard';
import { SystemUnavailableError } from '../../../../errors';
import { SlotUnavailableError } from '../../../../errors/SlotUnavailableError';
import ModalTimeNotAvailable from '../../../../components/ModalTimeNotAvailable';
import SystemUnavailable from '../../../../components/SystemUnavailable';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { ShowAlertByProduct } from './components/ShowAlertByProduct';
import { CallCenterModal } from '../../../../components/CallCenterModal';
import { MedicalRecorderError } from '../../../../errors/MedicalRecorderError';

export function AppointmentConfirmationList() {
  const router = useExecutiveCheckupRouter();
  const { scheduleItems } = useScheduleContext();
  const { patientSelected } = usePatientContext();
  const { selectedService } = useServiceContext();

  const [loading, setLoading] = React.useState(false);
  const [isModalSystemUnavailableVisible, setIsModalSystemUnavailableVisible] = React.useState(false);
  const [isModalSlotUnavailableVisible, setIsModalSlotUnavailableVisible] = React.useState(false);
  const [isCallCenterModalVisible, setIsCallCenterModalVisible] = React.useState(false);

  const handleError = (error: Error) => {
    if (error instanceof MedicalRecorderError) setIsCallCenterModalVisible(true);

    if (error instanceof SystemUnavailableError) setIsModalSystemUnavailableVisible(true);

    if (error instanceof SlotUnavailableError) setIsModalSlotUnavailableVisible(true);
  };

  const saveSchedules = async () => {
    setLoading(true);
    if (patientSelected) {
      const schedule = createScheduleRequest(patientSelected, scheduleItems, [], undefined, selectedService.id);

      try {
        const { token } = await saveSchedule(schedule);

        if (token) {
          router.navigate(Page.CONCLUSION, {
            productId: schedule.schedules[0]?.productId,
            token,
            productName: schedule.schedules[0].productName
          });
        } else throw new SystemUnavailableError('');
      } catch (error: any) {
        console.log('Error trying to schedule/reschedule', error);

        handleError(error);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <AppointmentConfirmationTemplate handleContinue={saveSchedules} loading={loading} goBack={() => router.goBack()}>
        {scheduleItems.map(schedule => (
          <>
            <ScheduleCard schedule={schedule} key={schedule.id} />
            <div style={{ marginTop: 24 }}>
              <ShowAlertByProduct productName={schedule.productName} />
            </div>
          </>
        ))}
      </AppointmentConfirmationTemplate>

      <ModalTimeNotAvailable
        visible={isModalSlotUnavailableVisible}
        onClose={() => setIsModalSlotUnavailableVisible(false)}
      />

      <SystemUnavailable
        visible={isModalSystemUnavailableVisible}
        onClose={() => setIsModalSystemUnavailableVisible(false)}
      />

      <CallCenterModal
        visible={isCallCenterModalVisible}
        onClose={() => setIsCallCenterModalVisible(false)}
        serviceId={selectedService.id || ''}
        serviceName={selectedService.name || ''}
        productId={scheduleItems[0].productId}
        productName={scheduleItems[0].productName || ''}
        unitId={scheduleItems[0].unit?.unitId || ''}
        unitName={scheduleItems[0]?.unit?.name || ''}
        textMessage={''}
      />
    </>
  );
}
